import { Badge, ResultsCard, ResultsToolbar, Table } from 'shared/components/ui';
import React from 'react';

import { UnfoldMore } from '@mui/icons-material';
import { useSortableTable } from '../../../../shared/hooks/useSortableTable';
import useDragScroll from '../../../../shared/hooks/useDragScroll';
import './TablaFacturacion.css';

const TablaFacturacion = ({ datos, tipo, onToggleSeleccion, onToggleAll, totales, acciones }) => {
  const { sortedData, requestSort, getSortIcon } = useSortableTable(datos, { key: 'f_Estudio', direction: 'asc' });
  const { ref: dragRef, onMouseDown, onMouseUp, onMouseMove, onMouseLeave } = useDragScroll();

  const tipoLabel = tipo === 'consultas' ? 'Consultas' : 'Prácticas';
  const subtotal = tipo === 'consultas' ? totales.consultasSubtotal : totales.practicasSubtotal;
  const copago = tipo === 'consultas' ? totales.consultasCopago : totales.practicasCopago;
  const total = tipo === 'consultas' ? totales.consultasTotal : totales.practicasTotal;

  return (
    <ResultsCard className="results-card">
      <ResultsToolbar className="results-header">
        <div className="results-header-left">
          <h3 className="results-title">Resultados de Facturación</h3>
        </div>
        <div className="results-info">
          <span className="results-count">
            {datos.filter(d => d.selected).length} de {datos.length} seleccionados
          </span>
          {acciones}
        </div>
      </ResultsToolbar>
      <div
        className="table-container table-container-scrollable"
        ref={dragRef}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        style={{ cursor: 'grab' }}
      >
        <Table className="data-table tabla-facturacion-os" hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th onClick={() => requestSort('rowNumber')} style={{ cursor: 'pointer' }}>
                Nro {getSortIcon('rowNumber') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('nroAfiliado')} style={{ cursor: 'pointer' }}>
                Nº Afiliado {getSortIcon('nroAfiliado') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('dni')} style={{ cursor: 'pointer' }}>
                DNI {getSortIcon('dni') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('apellido')} style={{ cursor: 'pointer' }}>
                Apellido {getSortIcon('apellido') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('nombre')} style={{ cursor: 'pointer' }}>
                Nombre {getSortIcon('nombre') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('f_Estudio')} style={{ cursor: 'pointer' }}>
                F. Estudio {getSortIcon('f_Estudio') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('codigo')} style={{ cursor: 'pointer' }}>
                Código {getSortIcon('codigo') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('practica')} style={{ cursor: 'pointer' }}>
                Práctica {getSortIcon('practica') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('forma')} style={{ cursor: 'pointer' }}>
                INT/DOM/AMB {getSortIcon('forma') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('nroFactura')} style={{ cursor: 'pointer' }}>
                Nº Fac. {getSortIcon('nroFactura') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('grav')} style={{ cursor: 'pointer' }}>
                Gravado {getSortIcon('grav') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('importe')} style={{ cursor: 'pointer' }}>
                Importe {getSortIcon('importe') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('medioIva')} style={{ cursor: 'pointer' }}>
                10.5% {getSortIcon('medioIva') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th onClick={() => requestSort('conCopago')} style={{ cursor: 'pointer' }}>
                Copago {getSortIcon('conCopago') || <UnfoldMore sx={{ fontSize: 14, opacity: 0.4, ml: 0.5 }} />}
              </th>
              <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Fact.</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, index) => {
              const originalIndex = datos.findIndex(d => d.idTurno === item.idTurno);
              return (
                <tr key={index} style={{ opacity: item.selected ? 1 : 0.5 }}>
                  <td>{item.rowNumber}</td>
                  <td>{item.nroAfiliado}</td>
                  <td>{item.dni}</td>
                  <td>{item.apellido}</td>
                  <td>{item.nombre}</td>
                  <td>{item.f_Estudio}</td>
                  <td>{item.codigo}</td>
                  <td>{item.practica}</td>
                  <td>{item.forma}</td>
                  <td>{item.nroFactura}</td>
                  <td>{item.grav}</td>
                  <td>${item.importe?.toFixed(2)}</td>
                  <td>${item.medioIva?.toFixed(2)}</td>
                  <td>${item.conCopago?.toFixed(2)}</td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={item.selected}
                      onChange={() => onToggleSeleccion?.('practicas', originalIndex)}
                      style={{ width: 18, height: 18, cursor: 'pointer', accentColor: '#28a745' }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <div className="totales-container">
        <Badge bg="primary" className="totales-badge totales-badge-subtotal">
          Subtotal {tipoLabel}: ${subtotal.toFixed(2)}
        </Badge>
        <Badge bg="danger" className="totales-badge totales-badge-copago">
          Copago {tipoLabel}: ${copago.toFixed(2)}
        </Badge>
        <Badge bg="success" className="totales-badge totales-badge-facturable">
          Total {tipoLabel}: ${total.toFixed(2)}
        </Badge>
      </div>
    </ResultsCard>
  );
};

export default TablaFacturacion;
